// extracted by mini-css-extract-plugin
module.exports = {"employee":"EmployeeSelectUI_employee__2WGc5","circle":"EmployeeSelectUI_circle__24zNa"};